import { io, type Socket } from "socket.io-client";

let socket: Socket | null = null;

export function getLiveSocket(): Socket {
  if (!socket) {
    socket = io("/live", {
      autoConnect: false,
      withCredentials: true,
      // Force WebSocket-only: skips the HTTP-polling → upgrade dance that
      // Vite's dev proxy drops mid-handshake.
      transports: ["websocket"],
    });
  }
  return socket;
}

export function disconnectLiveSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
